import { BTIconTextUnderline } from "commonComponents/btWrappers/BTIcon";
import { BTMenu } from "commonComponents/btWrappers/BTMenu/BTMenu";
import { isSelectionExclusivelyInTitle } from "commonComponents/btWrappers/editor/core/editor.utils";
import { type ICollapsableControl } from "commonComponents/btWrappers/editor/core/EditorControlBar/common/CollapsableControlGroup/CollapsableControlGroup";
import { EditorControlButton } from "commonComponents/btWrappers/editor/core/EditorControlBar/common/EditorControlButton/EditorControlButton";
import { InputRecaptureHackMenuItem } from "commonComponents/btWrappers/editor/core/EditorControlBar/common/InputRecaptureHack/InputRecaptureHack";
import { type ExtensionName } from "commonComponents/btWrappers/editor/core/extensions/editorExtensionUtils";
import { type IEditor } from "commonComponents/btWrappers/editor/core/useBTEditor.types";

const extensionId = "underline";
const friendlyName = "Underline";
const icon = <BTIconTextUnderline />;
const onClick = (editor: IEditor) => {
    return editor.tiptapEditor.chain().focus().toggleUnderline().run();
};

export const underlineControl: ICollapsableControl = {
    key: extensionId,
    isControlSupported(supportedExtensions: Set<ExtensionName>, editor: IEditor) {
        return (
            supportedExtensions.has(extensionId) && editor.editorState.mode !== "inlineControlsOnly"
        );
    },
    isControlEnabled({ tiptapEditor }) {
        return (
            tiptapEditor.can().chain().focus().toggleUnderline().run() &&
            !isSelectionExclusivelyInTitle(tiptapEditor, tiptapEditor.state.selection)
        );
    },
    expandedElement(editor) {
        return (
            <EditorControlButton
                friendlyName={friendlyName}
                data-testid="underlineControl"
                icon={icon}
                isToggled={editor.tiptapEditor.isActive(extensionId)}
                onClick={() => onClick(editor)}
                disabled={!this.isControlEnabled(editor)}
            />
        );
    },
    collapsedActiveKeys({ tiptapEditor }) {
        return tiptapEditor.isActive(extensionId) ? [extensionId] : [];
    },
    collapsedMenuItem(editor) {
        return (
            <InputRecaptureHackMenuItem
                editor={editor}
                menuComponent={BTMenu.Item}
                key={this.key}
                menuProps={{
                    testid: this.key,
                    icon,
                    disabled: !this.isControlEnabled(editor),
                    className: "btEditorControlBarMenuItem",
                    onClick: () => onClick(editor),
                }}
            >
                {friendlyName}
            </InputRecaptureHackMenuItem>
        );
    },
};
export default underlineControl;
